import { Injectable } from '@angular/core';
import { SettingsService } from './settings.service';
import { NetworkConstants } from 'na-lib';
import { collection, deleteDoc, doc,getDocs } from '@angular/fire/firestore';
import { FirestoreService } from './firestore.service';

type PassDataLookups = {
  templates: Array<{ id: string; name?: string }>;
  widgets: Array<{ id: string; name?: string }>;
  contentTypeByTemplateId: Record<string, string>;
};

@Injectable({
  providedIn: 'root'
})
export class FormResultService {
  db = this.firestore.db//getFirestore()

  constructor(private settingsService: SettingsService,
    private firestore:FirestoreService) { }

  deleteFormResult(resultId):Promise<void>{
    return new Promise(async (resolve, reject) => {
      try {

        const docRef = doc(this.db, NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$, NetworkConstants.COLLECTION_FORMWIDGET, resultId)
        const d  = await deleteDoc( docRef)

        resolve(d)
      } catch (error) {
        reject(error)  
        console.log(error)      
      } 
    })
  }

  async getPassTemplateDataOnce(): Promise<PassDataLookups> {
    const colRef = collection(
      this.db,
      NetworkConstants.COLLECTION_CONTEXTS,
      this.settingsService.contextId$,
      NetworkConstants.COLLECTION_PASSDEFINITIONS
    );

    const snap = await getDocs(colRef);

    const templates: Array<{ id: string; name?: string }> = [];
    const contentTypeByTemplateId: Record<string, string> = {};
    const widgetMap = new Map<string, string | undefined>();

    snap.docs.forEach(d => {
      const data: any = d.data();

      const templateName = data?.name ?? data?.displayName ?? data?.title ?? undefined;
      templates.push({ id: d.id, name: templateName });

      const contentType = data?.contentType ?? '';
      contentTypeByTemplateId[d.id] = contentType;

      const widgets = Array.isArray(data?.widgets) ? data.widgets : [];
      for (const w of widgets) {
        const wid = w?.id;
        if (!wid) continue;

        const wName =
          w?.name ??
          w?.displayName ??
          w?.label ??
          w?.title ??
          undefined;

        if (!widgetMap.has(wid) || (!widgetMap.get(wid) && wName)) {
          widgetMap.set(wid, wName);
        }
      }
    });

    const widgets = Array.from(widgetMap.entries()).map(([id, name]) => ({ id, name }));

    return { templates, widgets, contentTypeByTemplateId };
  }

}